import config from '../configs/environment.json';
import { EnvironmentKey, EnvironmentConfig } from '../types/enviromentType';
const getEnvironmentVariables = (stack: EnvironmentKey): EnvironmentConfig => {
  return config[stack];
};

export default getEnvironmentVariables;
